import { render, staticRenderFns } from "./ReboquistaInfo.vue?vue&type=template&id=56859b12"
import script from "./ReboquistaInfo.vue?vue&type=script&lang=js"
export * from "./ReboquistaInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports